export const maxInstallmentsOptions = [...Array(10).keys()].map(item => ({ label: (item + 1).toString(), value: item + 1 }))
